import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AgricultureMapConstants, BASE_LAYER_LIST, COMMON_LAYER_LIST, COMPONENT_ROUTE_MAPPING, LAYER_TYPES, LOCATIONS_LATLNG, LOCATIONS_ZOOM, MAP_OPTIONS, MOBILE_MAP_OPTIONS } from '../../constants/dims-map-constants';
import * as L from 'leaflet';
import 'src/assets/js/maplibs/L.control.HtmlLegend.js';
import 'src/assets/map-control/L.Control.ZoomBar.js';
import 'src/assets/js/maplibs/L.TileLayer.NoGap.js'
import { GisdataService } from '../../services/gisdata.service';
import { AgricultureDashboardDefaultParams, AgricultureDashboardRequiredParams } from '../../constants/dims-queryparams-constants';
import { NavigationEnd, Router, ActivatedRoute, Params } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { DataService } from '../services/data.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { HeatwaveDataService } from '../../side-bar/heat-watch/heatwave/heatwave-data.service';
import { MapService } from 'src/app/utils/map.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { RainfallActualDataService } from '../../side-bar/weather-forecast/rainfall-actual/rainfall-actual-data.service';
import { RainfallActualQcDataService } from '../../side-bar/weather-forecast/rainfall-actual-qc/rainfall-actual-qc-data.service';
import { SeamlessRfViewDataService } from '../../side-bar/nowcast-dashboard-v2/seamless-rf-view/seamless-rf-view-data.service';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { WhatsappAlertComponent } from '../whatsapp-alert/whatsapp-alert.component';
// import { AddUserComponent } from '../add-user/add-user.component';
import { LightningMapService } from '../../side-bar/lightning/lightning-dashboard/lightning-map/lightning-map.service';
import { SatelliteDataService } from '../../side-bar/satellite/services/satellite-data.service';
import { LOCATION_HIE } from '../../side-bar/satellite/constants/satellite-map-constants';
import { moduleSubModules, SubModule, subModuleRoute } from '../side-nav-menu/side-nav-menu.constants';

@Component({
  selector: 'app-gis-dims-map',
  templateUrl: './gis-dims-map.component.html',
  styleUrls: ['./gis-dims-map.component.scss']
})
export class GisDimsMapComponent implements OnInit {

  @Input() infoboxComponent: any;
  @Input() otherOptions: any;
  @Input() sidebarComponent: any;
  // @Input() count1: any;

  injectedService: any;
  queryParams: any = {};
  agricultureDefaultParams: any;
  paramsSubscription: any;
  map: any;
  layers: any = {
    baselayers: {},
    overlaylayers: {},
    heatmaplayers: {},
    stationlayers: {},
    stationlayersQC: [],
    aoiLayers: {},
    processedLayers: {},
    clickedBoundaryLayers: {}
  }
  activeLayers: any = {};
  mapId: any;
  componentType: any;
  dashboardType: any;
  selectedCommonLayers: any = '';
  metaInfo: any = {};
  userCount: number = 0;
  userLocationConfig: any = {};
  componentWiseData: any = {};
  dashboard: any;
  dataTabCSS: any;
  destroy: Subject<boolean> = new Subject<boolean>();
  url: any;
  params: any = {};
  routeParams: any = {
    component: null,
    dashboard: null
  }
  userLocType: any;
  htmlNewLegend: any;
  legendList: any = {};
  dataTabToggleVal = true
  isDataTabClicked = false;
  labelStrings = []
  activeSideMenu: any;
  isAnomalyPercentageActive: boolean = false;
  isRadarToggleActive: boolean = false;
  isStationActive: boolean = false;   // add this
  playButtonDisable = true;
  playPosition = 0;
  playFastSlow: boolean = false;
  activeGroup: any;
  blockNumber = 0;
  dateBlockNumMap: any = {};
  cityAlertsDisable: boolean = true;
  activeButton: any = 'Admin'
  hwMetaData = {}
  showLabels: any = {
    COUNTRY: false,
    STATE: false,
    DISTRICT: false
  }
  selectedTimeStamp: any;
  showThrobber: boolean = false;
  selectedSource: any
  sourceOptions: string[] = [];
  sourcePillMapping: any = {};
  counter: number;
  initialCounter: number;
  visitorCount: any = '6753';
  deviceInfo: any;
  type: any;
  actualView: any = 'HEATMAP';
  titleTag = {
    'wind-speed-forecast': ' - 10m above surface',
    'temperature-forecast': ' - 2m above surface',
    'humidity-forecast': ' - 2m above surface',
    'WIND': ' - 10m above surface',
    'TEMPERATURE': ' - 2m above surface',
    'HUMIDITY': ' - 2m above surface',
    'RAINFALL': ''
  }
  isLayerListClick: boolean = false;
  rfActualQCSrcList: any = {}
  stationlayerType: any = { 'Valid Stations': false, 'Invalid Stations': true }
  typeColorMapping: any = { 'Valid Stations': '#66ff66', 'Invalid Stations': '#ffad33' }
  isImageSliderOpen: boolean = false;
  isHourlyFormat = false;
  imageList: any = null;
  heatwavePlaybarChartData: any[] = [];
  heatwavePlaybarChartMax: number = 0;
  heatindexPlaybarChartData: any[] = [];
  heatindexPlaybarChartMax: number = 0;
  rainfallPlaybarChartData: any[] = [];
  rainfallPlaybarChartMax: number = 0;
  nowcastPlaybarChartData: any[] = [];
  nowcastPlaybarChartMax: number = 0;
  heatWatchIcons = moduleSubModules('heat');
  rainfallIcons = moduleSubModules('rainfall');
  fogIcons = moduleSubModules('fog');
  LightningIcons = moduleSubModules('light');

  landSubsidenceIcons = [
    {
      type: 'land-subsidence',
      label: 'Land Subsidence',
      icon: 'assets/imgs/land-subsidence.svg',
      route: ['/land-subsidence/ls']
    }
  ];

  satelliteIcons = moduleSubModules('satellite');
  forecastIcons = moduleSubModules('forecast');

  metwiseAlertsIcons = [
    {
      type: 'metwiseAlerts',
      label: 'Metwise Alerts',
      icon: 'assets/imgs/sun_RainCutout.svg',
      route: ['/metwiseAlerts/feed']
    }
  ];

  metMindIcons = [
    {
      type: 'metmind',
      label: 'metMIND',
      icon: 'assets/imgs/metmind_logo.svg',
      route: ['/metmind/live']
    }
  ];

  subscriptions: any = [];
  marker: any;
  // Set by enableLocation() when mobile geolocation resolves a drill-down; consumed once by
  // the feature map service right after it adds the boundary layer for that location, so the
  // map fits the boundary that is actually on screen instead of a separately-fetched proxy.
  pendingMobileAutoFit: boolean = false;
  isOpen: boolean = false;
  // activeSidebar: string = '';
  sidebarToggle: boolean = false
  /** fa-bars button: the module menu in app-side-nav-menu is open (see toggleModuleMenu) */
  moduleMenuOpen: boolean = false;
  selectedLocType: any;
  inputForBreadcrumb: any = [];
  isSatelliteModule: boolean = false;
  // Bounds of the automatic COUNTRY-level fitBounds (set by GisdataService); used by the Home button
  homeBounds: any = null;
  activeGroupName: any
  constructor(public gisdataService: GisdataService,
    private injector: Injector,
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private gisUtils: UtilsService,
    private hwDataSrv: HeatwaveDataService,
    public mapService: MapService,
    private deviceService: DeviceDetectorService,
    private rfActualDataSrv: RainfallActualDataService,
    private rfActualQCDataSrv: RainfallActualQcDataService,
    private seamlessDataSrv: SeamlessRfViewDataService,
    // private modalService: NgbModal,
    public lightningMapSrv: LightningMapService,
    private satelliteDataSrv: SatelliteDataService
  ) {
    this.updateRouteParams();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.destroy)
    ).subscribe(() => {
      this.updateRouteParams();
    });
    this.deviceInfo = this.deviceService.getDeviceInfo();
  }

  updateRouteParams() {
    this.url = this.router.url.split('?')[0];
    let splitUrl: any = this.url.split('/');
    // console.log("splitUrl",splitUrl);
    this.routeParams.component = splitUrl[splitUrl.length - 1];
    this.routeParams.dashboard = splitUrl[splitUrl.length - 2];
    if (splitUrl.includes('24')) {
      this.routeParams.component = splitUrl[splitUrl.length - 3];
      this.routeParams.dashboard = splitUrl[splitUrl.length - 4];
    }
    // console.log("routeParams:::",this.routeParams);

    // this.deviceInfo = this.deviceService.getDeviceInfo();
  }

  ngAfterViewInit(): void {
    this.revalidateMap();
    return;
  }

  revalidateMap(): void {
    window.dispatchEvent(new Event('resize'));
    if (this.map) {
      setTimeout(() => {
        this.map.invalidateSize();
      }, 200)
    }
  }

  ngOnInit(): void {
    this.mapId = 'map-' + this.otherOptions.mapId;
    if (this.isMobileDevice()) {
      this.dataTabToggleVal = false;
      this.isDataTabClicked = false;
    }
    this.revalidateMap();
    this.initializeMapContainer();
    this.fetchUserCount();
  }
  initializeMapContainer() {
    setTimeout(() => {
      const mapOptions = this.isMobileDevice() ? MOBILE_MAP_OPTIONS : MAP_OPTIONS;
      mapOptions['editable'] = true;
      this.map = (L.map as any)(this.mapId, mapOptions);
      const mapContainer = this.map.getContainer()
      if (this.routeParams.component == 'rainfall-actual' || this.routeParams.component == 'rainfall-actual-qc' || this.routeParams.component == 'nowcast' || this.routeParams.component == 'seamlessview') {
        mapContainer.classList.add('leaftet-custom-container')
      }
      // for cold wave map background color changes
      // if(this.routeParams.component == 'coldwave') {
      //   console.log("this.routeParams.component",this.routeParams.component);
      //   // mapContainer.classList.add('')
      //   mapContainer.classList.add('leaftet-coldwave-container')
      // }
      const mapZoom = this.isMobileDevice() ? MOBILE_MAP_OPTIONS.minZoom : MAP_OPTIONS.minZoom;
      this.map.setView(LOCATIONS_LATLNG[AgricultureMapConstants.LOCATIONS.INDIA], mapZoom);
      this.createPanes();
      this.addZoomBar();
      // this.getAndSetBaseLayers();
      this.subscribeEvents();
      this.enableLocation();
      // if(this.otherOptions.mapId == "mainGeoportal" || this.otherOptions.mapId == "analyticsMap"){
      //   this.addCoordinates();
      // }
      // this.gisUtils.getGisMapComp.next(this);
    }, 10);
  }

  private createPanes() {
    AgricultureMapConstants.PANE_LIST.forEach((pane: any) => {
      this.map.createPane(pane.name);
      this.map.getPane(pane.name).style.zIndex = pane.zindex;
    });
  }

  addZoomBar() {
    const homeZoom = this.isMobileDevice() ? MOBILE_MAP_OPTIONS.minZoom : MAP_OPTIONS.minZoom;
    // Home button must restore the same view set in initializeMapContainer
    let zoomBarControl = new (L as any).control.zoomBar({
      hideZoomToActual: !!this.otherOptions.hideZoomToActual,
      homeCenter: LOCATIONS_LATLNG[AgricultureMapConstants.LOCATIONS.INDIA],
      homeZoom: homeZoom,
      getHomeBounds: () => this.homeBounds
    });
    zoomBarControl.addTo(this.map);
  }
  getAndSetBaseLayers(index) {
    let tileLayers = this.gisdataService.addBaseTileLayers(BASE_LAYER_LIST[LAYER_TYPES.TILE_LAYER], index, this.map)
    this.layers.baselayers = Object.assign(tileLayers, {});
  }

  getHeatwavePlaybarSegmentHeight(value: number): string {
    if (!this.heatwavePlaybarChartMax || !value) {
      return '0%';
    }
    return ((value / this.heatwavePlaybarChartMax) * 100).toFixed(1) + '%';
  }

  getHeatindexPlaybarSegmentHeight(value: number, total?: number): string {
    const denominator = total && total > 0 ? total : this.heatindexPlaybarChartMax;
    if (!denominator || !value) {
      return '0dvh';
    }
    return ((value / denominator) * 100).toFixed(1) + 'dvh';
  }

  getRainfallPlaybarSegmentHeight(value: number): string {
    if (!this.rainfallPlaybarChartMax || !value) {
      return '0dvh';
    }
    return ((value / this.rainfallPlaybarChartMax) * 100).toFixed(1) + 'dvh';
  }

  getNowcastPlaybarSegmentHeight(value: number): string {
    if (!this.nowcastPlaybarChartMax || !value) {
      return '0dvh';
    }
    return ((value / this.nowcastPlaybarChartMax) * 100).toFixed(1) + 'dvh';
  }

  private subscribeEvents() {
    this.queryParams = { params: { ...this.route.snapshot.queryParams } };
    this.componentType = this.routeParams.component //this.gisdataService.isEmptyObj(this.route.snapshot.params) ? '' : this.route.snapshot.params['component'];
    // Returning here from the rainfallStations login gate (see onStationToggle()). The saved
    // drilldown (locType/pUUID/source/etc., captured right before the login redirect) is
    // restored below REGARDLESS of whether login succeeded, was cancelled, or failed —
    // resetVariablesOnComponentDestroy() already wiped both the shared UtilsService.selectedParams
    // and its sessionStorage('params') mirror down to {} on teardown, and without restoring it
    // here RainfallForecastSidebarComponent's own fresh-mount default-population (triggered by
    // this same teardown/remount) would otherwise reset the app back to the user's default
    // Country-level location — on Cancel/failed-login just as much as on success. Only actually
    // ACTIVATING Stations (isStationActive/actualView/forcing forecastLength='-7D' and calling
    // getSrcWiseLayers below) is gated on login having actually succeeded.
    let pendingRainfallStationsActivation = false;
    if (this.componentType === 'rainfall-forecast' && sessionStorage.getItem('rainfallStationsPendingActivation') === 'true') {
      sessionStorage.removeItem('rainfallStationsPendingActivation');
      const savedRainfallStationsParams = sessionStorage.getItem('rainfallStationsPendingParams');
      sessionStorage.removeItem('rainfallStationsPendingParams');
      const rainfallStationsLoginSucceeded = localStorage.getItem('isRainfallStationsUserLoggedIn') === 'true';
      if (savedRainfallStationsParams) {
        try {
          const savedParams = JSON.parse(savedRainfallStationsParams);
          if (savedParams && Object.keys(savedParams).length > 0) {
            pendingRainfallStationsActivation = rainfallStationsLoginSucceeded;
            // On success, getSrcWiseLayers() is called explicitly below once forecastLength
            // settles to '-7D' (see justActivatedRainfallStations), bypassing initMethods()'s own
            // actionType-gated rebuild entirely. On Cancel/failed login there's no such explicit
            // call, so actionType: 'filter' is set here to route through that same existing
            // gate (initMethods() below) — otherwise this restored (but not "filter") params
            // object would never trigger a layer rebuild on this freshly remounted map, leaving
            // it blank at the correct location instead of showing the restored HeatMap.
            this.gisUtils.setSelectedParams(rainfallStationsLoginSucceeded
              ? { ...savedParams, forecastLength: '-7D' }
              : { ...savedParams, actionType: 'filter' });
          }
        } catch (e) {
          console.error('Error restoring rainfall stations pending params:', e);
        }
      }
    }
    this.reorderHeatWatchIcons();
    this.reorderRainfallIcons();
    this.reorderForecastIcons();
    this.type = (this.routeParams.dashboard == 'weatherforecast' ||
      (this.routeParams.dashboard != 'heatwatch' && this.routeParams.component == 'temperature-forecast'))
      ? 'weatherforecast' : this.componentType
    // this.componentType = this.router.url.split('/').includes('satelliteDataProcessing') ? 'satelliteDataProcessing' : this.componentType;
    this.dashboard = this.router.url.includes('download') ? 'download' : '';
    this.dashboardType = this.dashboard ? this.dashboard : this.router.url.split('?')[0].split('/')[3];
    this.dataTabCSS = this.router.url.split('?')[0].split('/')[4];
    this.revalidateMap()
    this.selectedCommonLayers = AgricultureMapConstants.DASHBOARD_WISE_COMMON_LAYERS_KEY_MAPPING[this.componentType];
    this.injectedService = this.injector.get(this.otherOptions['serviceType']);
    this.isSatelliteModule = this.otherOptions.mapId === 'satellite';
    this.sourceOptions = this.otherOptions['sourceOptions'] || [];
    this.sourcePillMapping = this.otherOptions['sourceMapping'] || {};
    // getting metaInfo
    let metaInfo: any = localStorage.getItem('metaInfo');
    let metaInfoJson: any = !isNullOrUndefined(metaInfo) ? JSON.parse(metaInfo) : {};
    this.metaInfo = metaInfoJson;
    if (Object.keys(metaInfoJson).length > 0) {
      if (metaInfoJson && metaInfoJson.hasOwnProperty('userDetailsJson') && !isNullOrUndefined(metaInfoJson.userDetailsJson) && this.componentType != 'kolkataEvent' && this.componentType != 'kolkata2025' && this.componentType != 'jammuEvent') {
        this.userLocType = metaInfoJson.userDetailsJson.data.locType;
        this.userLocationConfig = this.dataService.formQuerParamsVariables(metaInfoJson.userDetailsJson.data.location, this.userLocType);
        // this.setQueryParams(this.userLocationConfig);
      } else if (metaInfoJson && metaInfoJson.hasOwnProperty('userDetailsJson') && !isNullOrUndefined(metaInfoJson.userDetailsJson) && (this.componentType == 'kolkataEvent' || this.componentType == 'kolkata2025')) {
        this.userLocType = 'State'
        this.userLocationConfig = this.dataService.formQuerParamsVariables({
          "country": [
            {
              "countryName": "India",
              "countryUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
              "state": [
                {
                  "stateName": "West Bengal",
                  "stateUUID": "119ff4d9-357d-46e7-a33a-341a10e2e26f",//"78170895-ec7a-42d6-b39f-2c4eaa001944"
                  "district": [
                    {
                      "districtName": "Kolkatta",
                      "districtUUID": "a755d090-4d93-47d3-91d6-d0c1b0f2a397"
                    }
                  ]
                }
              ]
            }
          ]
          // "country":[{"countryName":"INDIA","countryUUID":"00cb31c7-2928-4e6d-adcc-443d478c90d6","state":[{"stateName":"ASSAM","stateUUID":"0a2f9e86-49fa-4641-af48-f127a02a1a14","district":[{"districtName":"KAMRUP","districtUUID":"d7931e9c-bf3d-4b12-8e63-bb567d65228c"}]}]}]
        }, this.userLocType);
        // this.setQueryParams(this.userLocationConfig);
      } else if (metaInfoJson && metaInfoJson.hasOwnProperty('userDetailsJson') && !isNullOrUndefined(metaInfoJson.userDetailsJson) && this.componentType == 'jammuEvent') {
        this.userLocType = 'State'
        this.userLocationConfig = this.dataService.formQuerParamsVariables({
          "country": [
            {
              "countryName": "India",
              "countryUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
              "state": [
                {
                  "stateName": "Jammu And Kashmir",
                  "stateUUID": "3d62dad7-cca9-4b02-aff7-220a1e29434a",//"78170895-ec7a-42d6-b39f-2c4eaa001944"
                }
              ]
            }
          ]
          // "country":[{"countryName":"INDIA","countryUUID":"00cb31c7-2928-4e6d-adcc-443d478c90d6","state":[{"stateName":"ASSAM","stateUUID":"0a2f9e86-49fa-4641-af48-f127a02a1a14","district":[{"districtName":"KAMRUP","districtUUID":"d7931e9c-bf3d-4b12-8e63-bb567d65228c"}]}]}]
        }, this.userLocType);
        // this.setQueryParams(this.userLocationConfig);
      }
    } else if (this.otherOptions.loginRequired !== false) { // modules can opt out with otherOptions.loginRequired = false
      if (this.componentType === 'nowcast' || this.router.url.includes('nowcastweather')) {
        this.router.navigate(['/nowcastlogin']);
      } else if (this.componentType === 'fog' || this.router.url.includes('fogwatch')) {
        this.router.navigate(['/foglogin']);
      } else if (this.componentType === 'metwiseAlerts' || this.router.url.includes('metwiseAlerts')) {
        this.router.navigate(['/metwiseAlertsLogin']);
      } else {
        this.router.navigate(['/']);
      }
    }
    this.paramsSubscription = this.gisUtils.getSelectedParams().pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      if (!this.gisdataService.isEmptyObj(params)) {
        let routeParams: any = this.routeParams; //this.gisdataService.getWritableObject(this.route.snapshot.params);
        if (Object.keys(routeParams).length == 0) {
          routeParams = {
            component: 'cropAnalytics',
            dashboard: 'agriculture'
          };
        }
        if ((COMPONENT_ROUTE_MAPPING[params['component']] &&
          COMPONENT_ROUTE_MAPPING[params['component']] == routeParams['component']) || params['component'] == 'satelliteDataProcessing') {
          this.params = JSON.parse(JSON.stringify(params));
          this.updateGoogleMapsMarkerVisibility();
          // Force the -7D + STATIONS restore here, once this.params reflects the authoritative
          // shared state (rather than at subscribeEvents()'s own top, where the selectedParams
          // subscription may not have delivered a value with forecastLength settled to '-7D' yet
          // on a fresh mount of this lazy module). If it's not already '-7D', re-publish it with
          // forecastLength forced — the same shared-state mechanism app.-wide '-7D' time-menu
          // clicks use (see TimeMenuToggleComponent.routeChange()) — which re-enters this callback
          // with the corrected value; only then flip isStationActive/actualView, once.
          let justActivatedRainfallStations = false;
          if (pendingRainfallStationsActivation) {
            if (this.params['forecastLength'] !== '-7D') {
              this.gisUtils.setSelectedParams({ ...this.params, forecastLength: '-7D' });
              return;
            }
            pendingRainfallStationsActivation = false;
            justActivatedRainfallStations = true;
            this.isStationActive = true;
            this.actualView = 'STATIONS';
          }
          if (params['source']) {
            this.selectedSource = params['source'];
          }
          this.revalidateMap();
          this.initMethods();
          if (this.isSatelliteModule && this.injectedService && this.injectedService.getHeirarchyData) {
            this.injectedService.getHeirarchyData(this);
          }
          // initMethods() only rebuilds layers when actionType=='filter'/hasFilter/cropSownInformation
          // apply, none of which are guaranteed true on this return trip — call the map service's
          // entry point directly so the -7D heatmap (and, via its own isStationActive check, the
          // Stations layer) actually gets built rather than silently staying on a blank map.
          if (justActivatedRainfallStations && this.injectedService && this.otherOptions['functionName']) {
            this.injectedService[this.otherOptions['functionName']](this);
          }
        }
      }
    });
    // this.aoiParamsSubscription = this.gisUtils.aoiSelectedParams.subscribe((params: any) => {
    //   if (Object.keys(params).length > 0) {
    //     this.aoiParams = params;
    //     if (this.otherOptions.hasOwnProperty('aoiFunctionName')) {
    //       this.injectedService[this.otherOptions.aoiFunctionName](this);
    //     }
    //   }
    // });
    // this.dataTabSubscription = this.gisUtils.toggleSide.subscribe(event => {
    //   // this.toggleButtonsLeft['dataTabToggle'] = event;
    //    // First, reset all buttons to false
    //   for (const key in this.toggleButtonsLeft) {
    //     if (this.toggleButtonsLeft.hasOwnProperty(key)) {
    //       this.toggleButtonsLeft[key] = false;
    //     }
    //   }
    //   for (const key in this.toggleButtons) {
    //     if (this.toggleButtons.hasOwnProperty(key)) {
    //       this.toggleButtons[key] = false;
    //     }
    //   }
    //   // Then set the provided key to true
    //   const key = Object.keys(event)[0];
    //   if (key && this.toggleButtonsLeft.hasOwnProperty(key)) {
    //     this.toggleButtonsLeft[key] = event[key];
    //   }
    //   // this.toggleButtonsLeft['drawingTool'] = !event;
    //   if(this.routeParams.component == 'cropSownInformation') {
    //     this.toggleButtonsLeft['infoboxToggle'] = event[key];
    //   }
    // })
    // this.enableToolSubscription = this.gisUtils.enabledTools.subscribe(event => {
    //   if(this.toggleButtonsLeft['dataTabToggle']){
    //     this.toggleButtonsLeft['drawingTool'] = false;
    //   }
    // })
    // this.weatherForecastSidebarSub = this.gisUtils.getSidebarToggle().subscribe(data => {
    //   this.sidebarToggle = data;
    // })
    // this.weatherForecastSrv.getHieViewType().subscribe((hieType:any) => {
    //   this.weatherForecastHieType = hieType;
    //   let options: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams))
    //   options['hieType'] = isNullOrUndefined(this.weatherForecastHieType) ? 'Agri' : this.weatherForecastHieType;
    //   this.url = this.router.url.split('?')[0];
    //   let splitUrl: any = this.url.split('/');
    //   if(splitUrl.includes('weatherForecast')){
    //     this.router.navigate(['.'], {
    //       relativeTo: this.route,
    //       queryParams: options,
    //       queryParamsHandling: 'merge'
    //     });
    //   }
    // });
    //updating header count on radio button active in coldwave
    if (this.componentType === 'coldwave') {
      this.gisUtils.coldwaveIndex$
        .pipe(takeUntil(this.destroy))
        .subscribe(groupName => {
          if (!groupName) return;
          this.changeTimeLayers(groupName);
        });
    }
  }

  setQueryParams(userLocationConfig: any) { // setting params on the basis of metaInfo
    this.url = this.router.url.split('?')[0];
    let splitUrl: any = this.url.split('/');
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        // if (params.hasOwnProperty(param)) {
        this.queryParams[param] = params[param];
        this.params[param] = params[param]
        // }
      }
      this.agricultureDefaultParams = this.dataService.deepClone(AgricultureDashboardDefaultParams);
      const mergedParams = this.dataService.deepMerge(this.agricultureDefaultParams, this.queryParams);
      this.isHourlyFormat = mergedParams['format'] === 'HOURLY' || (mergedParams['params'] && mergedParams['params']['format'] === 'HOURLY');
      if (!isNullOrUndefined(userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()])) {
        let currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
        mergedParams['dashboardType'] = 'gis';
        mergedParams['pUUID'] = currentLocations[1]
        mergedParams['locName'] = currentLocations[0]
        mergedParams['locType'] = userLocationConfig.types.pType;
        mergedParams['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
        mergedParams['location'] = userLocationConfig.locationInfo.location;
        mergedParams['source'] = this.componentType != 'thunderstorm' ? 'IMD_LONG_RANGE' : 'ECMWF_KINDEX'
        mergedParams['view'] = 'Admin'
        if (splitUrl.includes('thunderstorms') || splitUrl.includes('rainfall-forecast') || splitUrl.includes('temperature-forecast') || splitUrl.includes('wind-speed-forecast') || splitUrl.includes('humidity-forecast')) {
          mergedParams['forecastLength'] = '24'
        }
        if (this.componentType == 'kolkataEvent') {
          mergedParams['source'] = 'MODEL_INPUT_NOWCAST',
            mergedParams['timeStamp'] = 1729351800000,
            mergedParams['date'] = '19_10_2024'
        }
        if (this.componentType == 'kolkata2025') {
          mergedParams['source'] = 'IMD_RADAR_NOWCAST',
            mergedParams['timeStamp'] = 1751776200000
        }
        if (this.componentType == 'jammuEvent') {
          mergedParams['source'] = 'EUMETSAT_NOWCAST',
            mergedParams['timeStamp'] = 1756488600000
        }
        if (this.componentType == 'nowcast' || this.componentType == 'kolkata-nowcast') {
          mergedParams['source'] = 'RADAR+CTT'
          if (this.componentType == 'kolkata-nowcast') {
            mergedParams['view'] = 'City'
            mergedParams['seamlessView'] = false
          }
        }
        if (this.componentType == 'seamlessview') {
          mergedParams['source'] = 'IMD_RADAR_MODEL_INPUT_NOWCAST'
          let dateObj = this.seamlessDataSrv.initializeDateDefaults()
          mergedParams['startDate'] = dateObj['startTs']
          mergedParams['endDate'] = dateObj['endTs']
        }
        if (this.componentType == 'abg-site') {
          mergedParams['forecastLength'] = '24'
          mergedParams['forecastType'] = 'RAINFALL'
          mergedParams['dashboardName'] = 'seamlessrf'
        }
        if (this.componentType == 'monitor') {
          mergedParams['source'] = 'AGENTIC_HAZARD'
          mergedParams['disasterType'] = 'Cyclone'
          mergedParams['startDate'] = '2017'
          mergedParams['endDate'] = '2025'
        }
        if (this.componentType == 'fog') {
          mergedParams['source'] = 'ecmwf_1hr'
          mergedParams['fogView'] = 'observed'
          mergedParams['format'] = 'DAILY'
        }
        if (this.componentType == 'rainfall-actual' || this.componentType == 'rainfall-actual-qc') {
          let dateObj = this.rfActualDataSrv.getQueryParamsForRFActual(mergedParams)
          mergedParams['source'] = this.componentType == 'rainfall-actual' ? 'IMD_STATIONS' : 'MERGED_STATIONS'
          mergedParams['sDate'] = this.componentType == 'rainfall-actual' ? dateObj['sDate'] : dateObj['eDate'];
          mergedParams['eDate'] = dateObj['eDate'];
          mergedParams['format'] = 'yyyyMMdd';
          mergedParams['aggr'] = 'SUM';
          mergedParams['view'] = 'HEATMAP'
          mergedParams['filter'] = false
          // mergedParams['mapClick'] = false
        }
      }

      if (!this.dataService.verifyAllParamsPresent(this.queryParams['params'], JSON.parse(JSON.stringify(AgricultureDashboardRequiredParams)))) {
        this.router.navigate(['.'], {
          relativeTo: this.route,
          queryParams: mergedParams,
          queryParamsHandling: 'merge'
        });
      }
      else {
        if (!(this.params['source'] == 'ECMWF' && (this.params['forecastLength'] == 'weekly' || this.params['forecastLength'] == 'monthly' || this.params['forecastLength'] == 'seasonal'))) {
          this.isAnomalyPercentageActive = false;
        }
        this.removeAllLayers();
        this.initMethods();
      }
    });
  }

  initMethods() {
    // if (!(this.params['source'] == 'ECMWF' && (this.params['forecastLength'] == 'monthly' || this.params['forecastLength'] == 'seasonal'))) {
    //   this.isAnomalyPercentageActive = false;
    // }
    // this.gisUtils.selectedFieldEvent.next({});
    if (this.params['actionType'] == 'filter' || this.routeParams.component == 'cropSownInformation' || this.otherOptions.hasFilter) {
      this.removeAllLayers();
      this.removeComponentWiseLayers();
      this.removeHeatMapLayers();
      this.injectedService[this.otherOptions['functionName']](this);
    }
    if (this.routeParams.component == 'drought') {
      this.injectedService[this.otherOptions['functionName']](this);
    }
    this.getAndSetUserLoginBasedLayers();
    // if(this.componentType == 'heatwave') {
    this.setHeatwaveInfo()
    this.setRainfallInfo()
    // }
  }

  setHeatwaveInfo() {
    this.setBlockNumbersForSidebar();
    this.getHeatwaveInfo()
    this.setSelectedTimestamp()
  }
  setRainfallInfo() {
    if (this.componentType == 'rainfall-forecast' && this.injectedService.setRainfallPlaybarChartData) {
      this.injectedService.setRainfallPlaybarChartData(this, this.params);
    }
  }

  setBlockNumbersForSidebar() {
    let savedIndex = localStorage.getItem("playBarIndex");
    if (this.componentType == 'heatwave') {
      this.blockNumber = !isNullOrUndefined(savedIndex) ? Number(savedIndex) : this.hwDataSrv.setBlockNumber();
    } else if ((this.componentType == 'nowcast' || this.componentType == 'kolkata-nowcast') && this.selectedSource != 'JAXA') {
      this.blockNumber = !isNullOrUndefined(savedIndex) ? Number(savedIndex) : this.selectedSource != 'EUMETSAT' ? 5 : 7;
    } else {
      this.blockNumber = !isNullOrUndefined(savedIndex) ? Number(savedIndex) : 0;
    }
    this.dateBlockNumMap = this.hwDataSrv.getLast7DaysDates(this.queryParams, this.componentType);
  }

  getHeatwaveInfo() {
    this.gisUtils.heatwaveMetaData.subscribe(data => {
      // if (this.queryParams['params']['locType'] != 'DISTRICT') {
      this.hwMetaData = data
      // }
      for (let key in this.showLabels) {
        this.showLabels[key] = false
      }
      this.showLabels[this.queryParams['params']['locType']] = true
      if (this.params['locType'] == 'COUNTRY') {
        const mapZoom = this.isMobileDevice() ? MOBILE_MAP_OPTIONS.minZoom : MAP_OPTIONS.minZoom;
        this.map.setView(LOCATIONS_LATLNG[AgricultureMapConstants.LOCATIONS.INDIA], mapZoom);
        // this.map.setView(LOCATIONS_LATLNG[AgricultureMapConstants.LOCATIONS.INDIA], LOCATIONS_ZOOM[AgricultureMapConstants.LOCATIONS.INDIA]);
      }
    })
  }

  setSelectedTimestamp() {
    this.gisUtils.getTimeStamp().subscribe(data => {
      this.selectedTimeStamp = data;
    })
  }

  async getAndSetUserLoginBasedLayers() {
    if (this.params['pUUID'] != '') {
      let dashboadWiseCommonLayers: any = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS[this.selectedCommonLayers]];
      if (Object.keys(dashboadWiseCommonLayers).length > 0 && !this.otherOptions.dontRenderCommonLayers) {
        this.addLocationWiseLayers(this.params, dashboadWiseCommonLayers);
      }
    }
    // let pUUID: any = this.queryParams.params.pUUID;
    // if (this.queryParams.params.pUUID != '') {
    //   let response: any = await this.getHighlightedLayer(locTypeMapping, pType, pUUID);
    //   let data: any = new L.GeoJSON(response.data);
    //   let bounds: any = data.getBounds();
    //   if (Object.keys(bounds).length > 0) {
    //     this.map.fitBounds(data.getBounds());
    //   }
    //   this.map.addLayer(this.layers.overlaylayers[pType]);
    //   this.spinner = false;
    // }
  }

  addLocationWiseLayers(queryParams: any, dashboadWiseCommonLayers: any) {
    let layersList: any = {};
    if (!isNullOrUndefined(queryParams.locType) && !this.otherOptions.dontLoadUserBasedLocation) {
      layersList[this.gisUtils.titleCase(queryParams.locType)] = dashboadWiseCommonLayers[this.gisUtils.titleCase(queryParams.locType) + ' Boundaries'];
      let geoJsonLayersBasedOnView = this.gisdataService.getApplicationBasedLayer(layersList, LAYER_TYPES.GEOJSON_LAYER);
      geoJsonLayersBasedOnView = this.formatLayersData(geoJsonLayersBasedOnView);
      this.addSrcWiseGEOJSONLayers(geoJsonLayersBasedOnView, queryParams);
      this.addLocationWiseWMSLayers(queryParams);
    }
  }

  formatLayersData(layerList: any) {
    for (let layerName in layerList) {
      if (layerList[layerName].layerOptions.cql_filter_value) {
        layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + this.params['pUUID'] + "'";
      }
    }
    return layerList;
  }

  addLocationWiseWMSLayers(queryParams: any) {
    let wmsLayerList: any = {};
    let currentLocType: any = queryParams.locType;
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let nextLevel: any = hie[hie.indexOf(currentLocType) + 1];
    let layerName: any = this.gisUtils.titleCase(nextLevel) + ' Boundary';
    // wmsLayerList[layerName] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName];
    // wmsLayerList[layerName+' Labels'] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName+' Labels'];
    // if (layerName != 'Farm Boundary') {
    //   let wmsLayersBasedOnView = this.gisdataService.getApplicationBasedLayer(wmsLayerList, LAYER_TYPES.WMS_LAYER);
    //   wmsLayersBasedOnView = this.formatWmsLayersData(wmsLayersBasedOnView, queryParams);
    //   this.addSrcWiseWMSLayers(wmsLayersBasedOnView);
    if (queryParams['locType'] == 'COUNTRY') {

      // wmsLayerList[layerName] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName];
    }
    // if(!layerName.includes("State")) {
    // if((this.routeParams.component == 'cropAnalytics' || this.routeParams.component == 'plotAddition' || this.routeParams.component == 'cropSownInformation') && queryParams.locType == 'DISTRICT') {
    //   wmsLayerList['District Labels'] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['District Boundary Labels'];
    // } else if((this.routeParams.component == 'cropAnalytics' || this.routeParams.component == 'plotAddition'|| this.routeParams.component == 'cropSownInformation') && queryParams.locType == 'BLOCK') {
    //   wmsLayerList['Block Labels'] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['Block Boundary Labels'];
    // }
    // else if((this.routeParams.component == 'cropAnalytics' || this.routeParams.component == 'plotAddition'|| this.routeParams.component == 'cropSownInformation') && queryParams.locType == 'PANCHAYAT') {
    //   wmsLayerList['Panchayat Labels'] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['Panchayat Boundary Labels'];
    // }
    // else if((this.routeParams.component == 'cropAnalytics' || this.routeParams.component == 'plotAddition'|| this.routeParams.component == 'cropSownInformation') && queryParams.locType == 'VILLAGE') {
    //   wmsLayerList['Village Labels'] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['Village Boundary Labels'];
    // }
    // if (queryParams['locType'] != 'COUNTRY') {
    wmsLayerList[layerName + ' Labels'] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName + ' Labels'];
    // }
    // }
    // if(layerName != 'Farm Boundary'){
    let wmsLayersBasedOnView = this.gisdataService.getApplicationBasedLayer(wmsLayerList, LAYER_TYPES.WMS_LAYER);
    wmsLayersBasedOnView = this.formatWmsLayersData(wmsLayersBasedOnView, queryParams);
    this.addSrcWiseWMSLayers(wmsLayersBasedOnView);
    // }
    // }
  }
  // formatWmsLayersData(layerList: any, queryParams?: any) {
  //   if (!isNullOrUndefined(queryParams)) {
  //     for (let layerName in layerList) {
  //       if (layerList[layerName].layerOptions.cql_filter_value) {
  //         let uuid: any = this.getLocationUUID(queryParams, layerList[layerName].layerOptions);
  //         layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
  //       }
  //     }
  //     return layerList;
  //   }
  // }
  formatWmsLayersData(layerList: any, queryParams?: any) {
    if (!isNullOrUndefined(queryParams)) {
      for (let layerName in layerList) {
        if (layerList[layerName].layerOptions.cql_filter_value) {
          let uuid: any = this.getLocationUUID(queryParams, layerList[layerName].layerOptions);
          layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
          // if(this.routeParams.component == 'cropAnalytics' || this.routeParams.component == 'plotAddition'|| this.routeParams.component == 'cropSownInformation') {
          if (queryParams.locType == 'STATE') {
            if (layerName == 'District Boundary Labels') {
              let allLocations: any = queryParams.location.split('&');
              let puuid = allLocations[1].split('##')[1]
              layerList[layerName].layerOptions.cql_filter_value = 'state_uuid'
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + puuid + "'";
            } else if (layerName == 'District Labels') {
              let allLocations: any = queryParams.location.split('&');
              let puuid = allLocations[2].split('##')[1]
              layerList[layerName].layerOptions.cql_filter_value = 'district_uuid'
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + puuid + "'";
            }
          }
          if (queryParams.locType == 'BLOCK') {
            if (layerName == 'Block Labels') {
              let allLocations: any = queryParams.location.split('&');
              let puuid = allLocations[3].split('##')[1]
              layerList[layerName].layerOptions.cql_filter_value = 'block_uuid'
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + puuid + "'";
            } else if (layerName == 'Panchayat Boundary Labels') {
              let allLocations: any = queryParams.location.split('&');
              let puuid = allLocations[3].split('##')[1]
              layerList[layerName].layerOptions.cql_filter_value = 'mandal_uui'
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + puuid + "'";
            }
          }
          if (queryParams.locType == 'PANCHAYAT') {
            if (layerName == 'Panchayat Labels') {
              let allLocations: any = queryParams.location.split('&');
              let puuid = allLocations[4].split('##')[1]
              layerList[layerName].layerOptions.cql_filter_value = 'uuid'
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + puuid + "'";
            } else if (layerName == 'Village Boundary Labels') {
              let allLocations: any = queryParams.location.split('&');
              let puuid = allLocations[4].split('##')[1]
              layerList[layerName].layerOptions.cql_filter_value = 'panchayat_uuid'
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + puuid + "'";
            }
          }
          if (queryParams.locType == 'VILLAGE') {
            if (layerName == 'Village Labels') {
              let allLocations: any = queryParams.location.split('&');
              let puuid;
              if (this.routeParams.component == 'plotAddition') {
                puuid = allLocations[4].split('##')[1]
              } else {
                puuid = allLocations[5].split('##')[1]
              }
              layerList[layerName].layerOptions.cql_filter_value = 'village_uuid'
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + puuid + "'";
            }
          }
          // }
        }
      }
      return layerList;
    }
  }

  getLocationUUID(queryParams: any, options: any) {
    let allLocations: any = queryParams.location.split('&');
    let uuid: any = '';
    if (options.layer_name == 'State Boundary' || options.layer_name == 'State Boundary Labels') {
      uuid = allLocations[1].split('##')[1]
    } else if (options.layer_name == 'District Boundary' || options.layer_name == 'District Boundary Labels') {
      uuid = allLocations[1].split('##')[1]
    } else if (options.layer_name == 'Block Boundary' || options.layer_name == 'Block Boundary Labels') {
      uuid = allLocations[2].split('##')[1]
    } else if (options.layer_name == 'Panchayat Boundary' || options.layer_name == 'Panchayat Boundary Labels') {
      uuid = allLocations[3].split('##')[1]
    } else if (options.layer_name == 'Village Boundary' || options.layer_name == 'Village Boundary Labels') {
      uuid = allLocations[4].split('##')[1]
    }
    //  else if (options.layer_name == 'Village Farm Level Boundary') {
    //   uuid = allLocations[4].split('##')[1]
    // }
    return uuid;
  }

  addSrcWiseWMSLayers(wmsLayersBasedOnView: any) {
    this.layers.overlaylayers = Object.assign({}, this.layers.overlaylayers, this.gisdataService.setWMSOverlays(this.map, wmsLayersBasedOnView, this.layers.overlaylayers));
  }

  addSrcWiseVECTORLayers(vectorLayersBasedOnView: any) {
    this.layers.overlaylayers = Object.assign({}, this.layers.overlaylayers, this.gisdataService.setVECTOROverlays(this.map, vectorLayersBasedOnView, null, this.layers.overlaylayers, this.params, this.queryParams.params, this));
  }

  addSrcWiseGEOJSONLayers(geoJsonLayersBasedOnView: any, queryParams?: any) {
    if (queryParams) {
      if (this.selectedLocType == queryParams.locType) return;
      this.selectedLocType = queryParams.locType
    }

    this.gisdataService.setGEOJSONOverlays(this.map, geoJsonLayersBasedOnView, this.layers, this.otherOptions, this).then(data => {
      this.layers.overlaylayers = Object.assign({}, this.layers.overlaylayers, data);
      // if (this.params.component && this.componentType != 'satelliteDataProcessing') {
      //   this.manageLegend();
      // }
      // if ((this.params.component && this.componentType != 'satelliteDataProcessing') || this.routeParams.component == 'cropSownInformation') {
      this.manageLegend();
      // }
    });
  }
  manageLegend() {
    if (!this.gisdataService.isEmptyObj(this.otherOptions.legend))
      this.otherOptions.legend = {};
    for (const key in this.activeLayers) {
      let layer = this.layers['overlaylayers'][key];
      if (layer) {

        if (!isNullOrUndefined(layer['options']['hasLegend']) || !isNullOrUndefined(layer['options']['legendName'])) {
          if (this.activeLayers[key]) {
            this.otherOptions['legend'][layer['options']['legendName']] = this.legendList[layer['options']['legendName']];
          }
          else {
            for (const i in this.legendList) {
              if (i == layer['options']['legendName'] && layer['options']['name'] != 'Village' && layer['options']['name'] != 'ADA' && layer['options']['name'] != 'Krishi Bhavan' && layer['options']['name'] != 'LAC') {
                delete this.otherOptions.legend[i];
              }
            }
          }
        }
      }
      if (this.params.component == 'CROPGROWTH' || this.params.component == 'CROPGROWTHANALYSIS') {
        if (this.params.locationType == 'user-defined') {
          let aoiLayers: any = this.layers.aoiLayers[key];
          if (!isNullOrUndefined(aoiLayers)) {
            if (!isNullOrUndefined(aoiLayers['options']['hasLegend']) || !isNullOrUndefined(aoiLayers['options']['legendName'])) {
              if (this.activeLayers[key]) {
                this.otherOptions.legend[aoiLayers['options']['legendName']] = this.legendList[aoiLayers['options']['legendName']];
              }
            }
          }
        }
      }
    }
    this.addLegend();
  }
  addLegend() {
    this.createLegend();
    let legendData;
    legendData = this.otherOptions['legend'];
    let legendValue;
    for (let key in legendData) {
      if (legendData[key]) {
        legendValue = this.getLegendData(legendData[key]);
        this.htmlNewLegend.addLegend(legendValue);
      }
    }
    this.checkLegendEvent();
  }

  createLegend() {
    this.removeUpdatedLegend();
    this.htmlNewLegend = new (L as any).Control.HtmlLegendForVisibility({
      position: 'bottomright',
      collapseSimple: false,
      detectStretched: false,
      collapsedOnInit: false,
      showByDefault: true
    });
    if (!isNullOrUndefined(this.htmlNewLegend)) {
      this.map.addControl(this.htmlNewLegend);
    }
  }

  removeUpdatedLegend() {
    if (this.htmlNewLegend) {
      this.map.removeControl(this.htmlNewLegend);
      this.htmlNewLegend.clearLegend();
    }
  }

  getLegendData(data: any) {

    let legend: any = {
      name: data.Units,
      elements: []
    }
    let isTrue = 1;

    if (isTrue == 1 && data.colorValues && data.colorValues.length > 0) {
      let html: any = ``, color;
      color = '#ffffff';
      for (let key = 0; key < data.colorValues.length; key++) {
        if (data.colorValues[key]['image']) {
          // html += `<p>${data.colorValues[key].max}</p>`;
          // html = data.HTML ? data.HTML : "<p><img src='" + data.colorValues[key]['image'] + "'/></p>";
          //   html = data.HTML ? data.HTML : `
          //   <div class='d-flex gap-2'>
          //   <img class='d-block h-200px' src="${data.colorValues[key]['image']}"/>
          //     <div class='h-200px d-flex flex-column justify-content-between'>
          //       <p class='m-0'>${data.colorValues[key].max}</p>
          //       <p class='m-0'>${data.colorValues[key].min}</p>
          //     </div>
          // </div>
          //   `;
          // html += `<p>${data.colorValues[key].min}</p>`;
          // if (data.colorValues[key]['image'] === '../../../../../assets/imgs/visibilityDashboards/miTanks/MITankPolygon.png') {
          // } else {
          html += `<div class="d-flex align-items-center p-2"><img  src='${data.colorValues[key].image}' class="ml-1 mr-2"></><p class="m-0">${data.colorValues[key].text}</p></div>`;
          // }
        } else {
          if (this.routeParams.component != "humidityForecast" && this.routeParams.component != "temperatureForecast" && this.routeParams.component != "temperatureActual" && this.routeParams.component != "humidityActual") {
            if (data.colorValues[key].backgroundColor) {
              html += `<div class="heat-watch-legend"><p style='background-color: ${data.colorValues[key].backgroundColor}; color: ${data.colorValues[key].textColor}; font-weight: bold;white-space:nowrap'>${data.colorValues[key].text}</p></div>`;
            }
            if (data.colorValues[key].borderColor) {
              html += `<div></span><span style='border: 2px solid  ${data.colorValues[key].borderColor}; background-color: #FFFFFF; border-radius:50%;'></span><p>${data.colorValues[key].text}</p></div>`;
            }
          }
          // else if(this.routeParams.component == 'geoportal'){
          //    html += `<div><img  src='${data.colorValues[key].imgurl}'></><p>${data.colorValues[key].text}</p></div>`;
          // }
          else {
            const ranges = data.colorValues;
            // for (let i = ranges.length - 1; i >= 0; i--) {
            // html +=
            // '<p class="my-0 font-weight-bold text-center" style="background-color: ${data.colorValues[key].backgroundColor} " ; color:' + ranges[i]['color'] + '"><span style="postition = absolute; padding:0,20px;">' + ranges[i].text + '</span></p>';
            // }

            html += `<div style="background-color:${data['colorValues'][key]['backgroundColor']} ; color:${data.colorValues[key].text}; height: 24px;
            width: 60px; text-wrap: nowrap; color:#FFF; padding-left: 4px;"><span style="postition = absolute; padding:0,20px;">${data.colorValues[key].text}</span></div>`;
          }

          // html +=  `<div class="my-0 font-weight-bold text-center" style="background-color:' + ${data.colorValues[key].backgroundColor}+ ' ; color:' + data.colorValues[key].text} + '"><span style="postition = absolute; padding:0,20px;">' + ranges[i].text + '</span></div>';
        }
      }
      legend['elements'].push({ html: html });

    } else if (data.HTML || data.image) {
      let html = data.HTML ? data.HTML : "<img src='" + data.image + "'/>";
      legend.elements.push({ html: html });
    }
    return legend;
  }

  checkLegendEvent() {
    let legendEvent: any = document.getElementsByClassName('leaflet-legend-close')[0];
    if (legendEvent) {
      legendEvent.addEventListener("click", (event: any) => {
        this.alterLegendStyle();
      });
    }
  }

  alterLegendStyle() {
    let legendElem: any = document.getElementsByClassName('leaflet-control leaflet-legend')[0];
    let elems: any = legendElem.style.transform.split(',');
    if (elems && elems[1] && elems[1].split('px').length > 0) {
      let val: any = Number(elems[1].split('px')[0]);
      if (val > 115 || val < -350) {
        // legendElem.style = "margin-bottom: 0px; transform: translate3d(-118.564px, 44.7731px, 0px);";
        // legendElem.style.transform = "";
        // legendElem.setAttribute("style","margin-bottom: 0px;");
        this.addLegend();
        let legendClose: any = document.getElementsByClassName('leaflet-legend-close')[0];
        legendClose.click();
      }
    }
  }

  ngOnDestroy() {
    if (this.otherOptions.hooks && !!Object.keys(this.otherOptions.hooks).length && this.otherOptions.hooks.destroy) {
      this.injectedService[this.otherOptions.hooks.destroy](this);
    }
    if (this.paramsSubscription) {
      this.paramsSubscription.unsubscribe();
    }
    // if (this.aoiParamsSubscription) {
    //   this.aoiParamsSubscription.unsubscribe();
    // }
    // if(this.dataTabSubscription) {
    //   this.dataTabSubscription.unsubscribe();
    // }
    // if(this.enableToolSubscription) {
    //   this.enableToolSubscription.unsubscribe();
    // }
    this.resetVariablesOnComponentDestroy();
    this.destroy.next(true);
    this.destroy.complete();
    this.subscriptions.forEach((subscription: Subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    })
    localStorage.removeItem('selectedBaseMapIndex')
  }

  resetVariablesOnComponentDestroy() {
    this.gisUtils.setSelectedParams({});
    sessionStorage.removeItem('params');
  }

  removeComponentWiseLayers() {
    for (const key in this.layers.overlaylayers) {
      let layer = this.layers.overlaylayers[key]['options'];
      if (layer['component'] && (layer['component'] == this.params['component'])) {
        if (this.map.hasLayer(this.layers.overlaylayers[key])) {
          this.map.removeLayer(this.layers.overlaylayers[key])
        }
        delete this.layers.overlaylayers[key];
      }
    }
  }

  removeAllLayers() {
    for (const key in this.layers.overlaylayers) {
      if (this.map.hasLayer(this.layers.overlaylayers[key])) {
        this.map.removeLayer(this.layers.overlaylayers[key]);
      } else if (this.map.hasLayer(this.layers.overlaylayers[key]['layer'])) {
        // this.map.removeLayer(this.layers.overlaylayers[key]['layer'])
      }
      delete this.layers.overlaylayers[key];
    }

    if (Object.keys(this.layers.processedLayers).length > 0) {
      for (const key in this.layers.processedLayers) {
        let processedLayer = this.layers.processedLayers[key];
        if (processedLayer) {
          for (const elem in processedLayer) {
            if (this.layers.processedLayers[key][elem].layerConfig && this.map.hasLayer(this.layers.processedLayers[key][elem].layerConfig)) {
              this.map.removeLayer(this.layers.processedLayers[key][elem].layerConfig);
            }
          }
        }
        delete this.layers.processedLayers[key];
      }
    }
  }

  removeHeatMapLayers() {
    if (Object.keys(this.layers.aoiLayers)) {
      Object.keys(this.layers.aoiLayers).forEach((layerName: any) => {
        const layer: any = this.layers.aoiLayers[layerName].options;
        if (layer.component && layer.component == this.params.component) {
          if (this.map.hasLayer(this.layers.aoiLayers[layerName])) {
            this.map.removeLayer(this.layers.aoiLayers[layerName]);
          }
          delete this.layers.aoiLayers[layerName];
        }
      });
    }
  }

  addCoordinates() {
    const Coordinates = L.Control.extend({
      onAdd: (map: any) => {
        const container = L.DomUtil.create("div");
        // container.className = 'latlng-mousehover';
        map.addEventListener("mousemove", (e: any) => {

          container.innerHTML = `
          <span class='latlng-mousehover'>Lat:
            ${e.latlng.lat.toFixed(
            6
          )} <br>Long:  ${e.latlng.lng.toFixed(6)}
            </span>
          `;
        });
        return container;
      }
    });

    this.map.addControl(new Coordinates({ position: "bottomleft" }));
  }
  // dataTabToggle() {
  //   this.dataTabToggleVal = !this.dataTabToggleVal
  //   this.revalidateMap()
  // }

  /** fa-bars module menu opens in place of the side nav icon bar, so the map width changes like the infobox toggle */
  toggleModuleMenu(open: boolean) {
    this.moduleMenuOpen = open;
    this.revalidateMap();
  }

  dataTabToggle() {
    if (this.isMobileDevice()) {
      this.dataTabToggleVal = !this.dataTabToggleVal;
      this.isDataTabClicked = this.dataTabToggleVal;
      this.revalidateMap();
      return;
    }
    const isHeatWatchComponent = ['heatwave', 'heatindex', 'land-surface-temp', 'temperature-forecast', 'seamless-temp', 'rainfall-forecast', 'fog', 'heatlog', 'light', 'ls', 'nowcast', 'seamlessview', 'wind-speed-forecast', 'humidity-forecast', 'ctt', 'feed', 'uv-forecast'].includes(this.componentType);
    if (isHeatWatchComponent && this.dataTabToggleVal && !this.isDataTabClicked) {
      this.isDataTabClicked = true;
    } else {
      this.dataTabToggleVal = !this.dataTabToggleVal;
      if (isHeatWatchComponent) {
        this.isDataTabClicked = this.dataTabToggleVal;
      }
    }
    this.revalidateMap();
  }

  activeMenu(event: any) {
    this.activeSideMenu = event;
  }

  changeTimeLayers(groupName) {
    if (this.componentType != 'thunderstorm' && this.componentType != 'nowcast' && this.componentType != 'kolkata-nowcast' && !this.componentType.includes('forecast')) {
      const activeIndex = this.labelStrings.findIndex(l => l.groupName == groupName);
      if (activeIndex > -1) {
        this.blockNumber = activeIndex;
      } else {
        this.blockNumber = this.dateBlockNumMap[parseInt(groupName, 10)];
      }

      // if (this.componentType == 'heatwave') {
      //   this.gisUtils.setTimeStamp(groupName);
      // }
    } else if (this.componentType.includes('forecast')) {
      const fl = this.params ? this.params['forecastLength'] : null;
      if (fl === 'weekly' || fl === 'monthly' || fl === 'seasonal') {
        const activeIndex = this.labelStrings.findIndex(l => l.groupName == groupName);
        if (activeIndex > -1) {
          this.blockNumber = activeIndex;
        }
      }
      else if (groupName != ' 24hr') {
        this.counter = parseInt(groupName, 10);
        if (this.componentType == 'uv-forecast' && this.params['forecastLength'] == '24') {
          // UV's +24H play bar advances in 1-hour blocks (24/day), unlike the
          // 3-hour blocks used by wind-speed-forecast/humidity-forecast.
          this.blockNumber = Math.floor(
            (this.counter - this.initialCounter) / 3600000
          );
        } else if (!this.componentType.includes('windspeed') && this.params['forecastLength'] == '10') {
          this.blockNumber = Math.floor(
            (this.counter - this.initialCounter) / 86400000
          );
        } else if (this.componentType == 'windspeed-forecast' && this.params['forecastLength'] == '10') {
          this.blockNumber = Math.floor(
            // (this.counter - this.initialCounter) / 10800000
            (this.counter - this.initialCounter) / 21600000
          );
        } else {
          this.blockNumber = Math.floor(
            (this.counter - this.initialCounter) / 10800000
            // (this.counter - this.initialCounter) / 21600000
          );
        }
      } else {
        this.blockNumber = 8;
      }
    } else if (this.params['forecastLength'] == '24') {
      this.counter = parseInt(groupName, 10)
      this.blockNumber = groupName != '24hr' ? Math.floor(
        (this.counter - this.initialCounter) / 10800000) : 8;
    } else if (this.params['forecastLength'] == '10') {
      this.blockNumber = Math.floor(
        (this.counter - this.initialCounter) / 86400000);
    } else if (this.componentType == 'nowcast' || this.componentType == 'kolkata-nowcast') {
      this.counter = parseInt(groupName, 10);
      if (this.selectedSource == 'JAXA') {
        this.blockNumber = Math.floor(
          (this.counter - this.initialCounter) / 3600000 // 1 hour in milliseconds
        );
      } else if (this.selectedSource != 'EUMETSAT') {
        // this.blockNumber = Math.floor(
        //   (this.counter - this.initialCounter) / 600000 // 10 minutes in milliseconds
        // );
      } else if (this.selectedSource == 'EUMETSAT') {
        // this.blockNumber = Math.floor(
        //   (this.counter - this.initialCounter) / 900000 // 15 minutes in milliseconds
        // );
      }
    }
    // console.log("BLOCKNUMBER::", this.blockNumber, this.initialCounter);
    this.injectedService[this.otherOptions['animationLayers']](this, groupName)
  }

  changePlayPos(event: any) {
    this.playPosition = event;
  }

  onSatelliteAnimationPageEnd() {
    if (this.isSatelliteModule && this.injectedService && this.injectedService.onAnimationPageEnd) {
      this.injectedService.onAnimationPageEnd();
    }
  }

  onSatellitePlayStarted() {
    if (this.isSatelliteModule && this.injectedService && this.injectedService.onPlayStarted) {
      this.injectedService.onPlayStarted();
    }
  }

  downloadReport(data: Blob, fileName: any) {
    const filename = fileName + "_Report" + ".pdf";
    const PDF_TYPE = "application/pdf;charset=utf-8";
    if (!data) {
      this.showThrobber = false;
      return;
    }
    const blob = new Blob([data], { type: PDF_TYPE });
    const objectUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    a.target = "_blank";
    a.click();
    setTimeout(() => {
      this.showThrobber = false;
    });
  }

  routeChange(type: any) {
    let options = { ... this.params }
    options['view'] = type;
    options['locName'] = "India"
    options['locType'] = "COUNTRY"
    options['location'] = "India##00cb31c7-2928-4e6d-adcc-443d478c90d6"
    options['pUUID'] = "00cb31c7-2928-4e6d-adcc-443d478c90d6"
    this.activeButton = type
    this.gisUtils.setSelectedParams(options)
  }

  routeToNowcast() {
    this.router.navigate(['', 'nowcastweather', 'forecast'])
  }

  layerToggle(type: any) {
    this.actualView = type
    this.injectedService[this.otherOptions['changeAnimationLayer']](this)
  }

  handleEventFromSearch(data) {
    this.map.flyTo(
      [data.location.lat, data.location.long],
      ProjConstants.LOCATION_ZOOM_MAPPING[data["et"]]
    );
  }

  toggleLayerList() {
    this.isLayerListClick = !this.isLayerListClick
  }

  showAndHideLayer(layer, source) {
    if (this.map.hasLayer(layer.value.layer)) {
      this.map.removeLayer(layer.value.layer)
      layer.value.visible = !layer.value.visible
    }
    else {
      this.map.addLayer(layer.value.layer)
      layer.value.visible = true
    }
  }

  showAndHideStationQCLayer(type, event) {
    Object.keys(this.stationlayerType).forEach(key => {
      if (key == type) {
        this.stationlayerType[key] = true
      }
      else {
        this.stationlayerType[key] = false
      }
    })
    for (let i in this.layers.stationlayersQC) {
      let layer = this.layers.stationlayersQC[i]
      if (this.stationlayerType[type] && type == 'Valid Stations' && layer['name'] == 'Invalid Stations') {
        this.map.removeLayer(layer['layer'])
      } else if (this.stationlayerType[type] && type == 'Invalid Stations' && layer['name'] == 'Valid Stations') {
        this.map.removeLayer(layer['layer'])
      }
      if (layer.name == type && this.map.hasLayer(layer['layer']) && !event.target.checked) {
        this.map.removeLayer(layer['layer'])
      } else if (layer.name == type && !this.map.hasLayer(layer['layer']) && event.target.checked && this.rfActualQCSrcList[layer['source']]) {
        this.map.addLayer(layer['layer'])
      }
    }
  }

  onCheckboxChange(item, event) {
    this.rfActualQCSrcList[item] = event.target.checked;
    for (let i in this.layers.stationlayersQC) {
      let layer = this.layers.stationlayersQC[i]
      if (layer['source'] == item && this.map.hasLayer(layer['layer']) && !event.target.checked) {
        this.map.removeLayer(layer['layer'])
      } else if (layer['source'] == item && !this.map.hasLayer(layer['layer']) && event.target.checked && this.stationlayerType[layer['name']]) {
        this.map.addLayer(layer['layer'])
      }
    }
  }

  moveToValidState() {
    this.injectedService['moveStationsToValidStateOnClick'](this)
  }

  toggleImageSlider() {
    if (isNullOrUndefined(this.imageList)) {
      this.injectedService.toastr.info("Select any event to view images")
      return
    }
    if (this.imageList.length > 0) {
      this.isImageSliderOpen = !this.isImageSliderOpen
    } else {
      this.injectedService.toastr.info("No Images Available")
    }
  }

  openDisasterTable() {
    this.injectedService['openDisasterTablePopup'](this)
  }
  goToLandingPage() {
    this.router.navigate(['landing-page']);
  }
  reorderHeatWatchIcons() {
    // console.log('reorderHeatWatchIcons - Initial heatWatchIcons order:', this.heatWatchIcons.map(i => i.label));
    const active = this.componentType;

    const storedStr = sessionStorage.getItem('heatWatchIconOrder');
    if (storedStr) {
      try {
        const storedOrder = JSON.parse(storedStr);
        if (Array.isArray(storedOrder) && storedOrder.length === this.heatWatchIcons.length) {
          this.heatWatchIcons.sort((a, b) => {
            return storedOrder.indexOf(a.type) - storedOrder.indexOf(b.type);
          });
          // console.log('reorderHeatWatchIcons - Restored order from sessionStorage:', this.heatWatchIcons.map(i => i.label));
        }
      } catch (e) {
        console.error('Error parsing stored heatWatchIconOrder', e);
      }
    }

    const activeIconIndex = this.heatWatchIcons.findIndex(i => i.type === active);
    if (activeIconIndex > -1) {
      const activeIcon = this.heatWatchIcons.splice(activeIconIndex, 1)[0];
      this.heatWatchIcons.unshift(activeIcon);

      // console.log('reorderHeatWatchIcons - Final order after moving active to top:', this.heatWatchIcons.map(i => i.label), this.heatWatchIcons);

      // Save new order to sessionStorage to persist across component recreations
      const newOrder = this.heatWatchIcons.map(i => i.type);
      sessionStorage.setItem('heatWatchIconOrder', JSON.stringify(newOrder));
    }
  }

  reorderRainfallIcons() {
    const active = this.componentType === 'seamlessview' ? 'nowcast' : this.componentType;

    const storedStr = sessionStorage.getItem('rainfallIconOrder');
    if (storedStr) {
      try {
        const storedOrder = JSON.parse(storedStr);
        if (Array.isArray(storedOrder) && storedOrder.length === this.rainfallIcons.length) {
          this.rainfallIcons.sort((a, b) => storedOrder.indexOf(a.type) - storedOrder.indexOf(b.type));
        }
      } catch (e) {
        console.error('Error parsing stored rainfallIconOrder', e);
      }
    }

    const activeIconIndex = this.rainfallIcons.findIndex(i => i.type === active);
    if (activeIconIndex > -1) {
      const activeIcon = this.rainfallIcons.splice(activeIconIndex, 1)[0];
      this.rainfallIcons.unshift(activeIcon);
      const newOrder = this.rainfallIcons.map(i => i.type);
      sessionStorage.setItem('rainfallIconOrder', JSON.stringify(newOrder));
    }
  }

  reorderForecastIcons() {
    const active = this.componentType === 'forecast' ? 'wind-speed' : this.componentType;
    const activeIconIndex = this.forecastIcons.findIndex(i => i.type === active);
    if (activeIconIndex > -1) {
      const activeIcon = this.forecastIcons.splice(activeIconIndex, 1)[0];
      this.forecastIcons.unshift(activeIcon);
    }
  }

  navigateToModule(item: Pick<SubModule, 'route' | 'loginFlag' | 'loginRoute'>) {
    this.router.navigate(subModuleRoute(item));
  }

  fetchUserCount() {
    this.gisUtils.getUserCountApi()
      .subscribe({
        next: (res) => {
          this.setVisitorsFromTopPages(res.topPages || []);
        },
        error: (err) => {
          console.error('Error fetching user count', err);
        }
      });
  }

  setVisitorsFromTopPages(topPages: any[]) {
    const currentRoute = this.router.url.split("?")[0];
    //  const matchedPage = topPages.find((page) => page.page === currentRoute);
    // if (matchedPage) { this.userCount = Number(matchedPage.views) || 0; }
    // else { this.userCount = 0; }
    // Use only the module-level base path (first 3 segments, e.g. /heatwatch/heatwave)
    // so this stays stable across drill-down navigations that append state/district to the URL.
    const baseRoute = currentRoute.split('/').slice(0, 3).join('/');
    const matchedPages = topPages.filter(page => page.page.includes(baseRoute));
    this.userCount = matchedPages.reduce((sum, page) => sum + (Number(page.views) || 0), 0);
  }

  isMobileDevice(): boolean {
    return this.deviceInfo["deviceType"] === 'mobile' || window.innerWidth < 768;
  }

  addMarkerForCurrentLocation() {
    if (this.componentType == 'live' || this.componentType == 'ls') return
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const latitude = pos.coords.latitude;
        const longitude = pos.coords.longitude;
        localStorage.setItem('userLocation', JSON.stringify({ latitude, longitude }));
        this.addMarkerForWebpage(latitude, longitude);
      },
      (err) => console.error('[enableLocation] geolocation error:', err)
    );
  }

  enableLocation() {
    if (!this.isMobileDevice()) {
      this.addMarkerForCurrentLocation()
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const latitude = pos.coords.latitude;
        const longitude = pos.coords.longitude;
        localStorage.setItem('userLocation', JSON.stringify({ latitude, longitude }));
        this.map.flyTo([latitude, longitude], 12, { duration: 1.5 });
        this.addMarker(latitude, longitude);
        this.setLocationBasedOnLatLongs(latitude, longitude)
      },
      (err) => console.error('[enableLocation] geolocation error:', err)
    );
  }

  /**
   * Called by a feature map service right after it has added the boundary layer for the
   * currently selected location. Only acts once per mobile auto drill-down (guarded by
   * pendingMobileAutoFit), so it never disturbs desktop or manual drill-down zoom behaviour.
   */
  fitBoundsForCurrentLocation(queryParams: any) {
    if (!this.pendingMobileAutoFit || !queryParams || !queryParams.pUUID) {
      return;
    }
    this.pendingMobileAutoFit = false;
    const boundaryLayerByLocType: any = {
      STATE: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
      DISTRICT: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
      BLOCK: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED'
    };
    const boundaryLayer = boundaryLayerByLocType[queryParams.locType];
    if (!boundaryLayer) {
      return;
    }
    this.gisUtils.getFeatureByUUID(queryParams.pUUID, boundaryLayer).subscribe(
      (res: any) => {
        if (res && res.features && res.features.length > 0) {
          const geoLayer = (L as any).geoJSON(res);
          const bounds = geoLayer.getBounds();
          if (bounds && bounds.isValid() && this.map) {
            this.map.fitBounds(bounds, { padding: [10, 10] });
          }
        }
      },
      (err) => console.error('[fitBoundsForCurrentLocation] error:', err)
    );
  }

  addMarker(lat: number, lon: number) {
    if (this.marker) {
      this.map.removeLayer(this.marker);
    }
    const customIcon = L.icon({
      iconUrl: 'assets/imgs/google-maps.png',
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32]
    });
    this.marker = L.marker([lat, lon], { icon: customIcon, pane: 'measuretool' })
    if (this.supportsGeoDrilldown()) {
      this.marker.addTo(this.map);
    }
    this.map.setView([lat, lon], 14);
  }

  addMarkerForWebpage(lat: number, lon: number) {
    if (this.marker) {
      this.map.removeLayer(this.marker);
    }
    const customIcon = L.icon({
      iconUrl: 'assets/imgs/google-maps.png',
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32]
    });
    this.marker = L.marker([lat, lon], { icon: customIcon, pane: 'measuretool' })
    if (this.supportsGeoDrilldown()) {
      this.marker.addTo(this.map);
    }
    this.marker.on('click', (e: any) => {
      this.setLocationBasedOnLatLongs(lat, lon)
    })
    // this.map.setView([lat, lon], 14);
  }

  /**
   * Single source of truth for whether the current view supports geographical (map/table)
   * drilldown — used to control the assets/imgs/google-maps.png marker's visibility. Only
   * Rainfall Forecast has sources/views that don't support it: YTD's IMD-STATION source, and
   * the Basin view under +6W/+7M/MONSOON. Every other module/time-menu/source keeps supporting
   * drilldown.
   */
  supportsGeoDrilldown(): boolean {
    if (this.componentType !== 'rainfall-forecast' || !this.params) {
      return true;
    }
    const forecastLength = this.params['forecastLength'];
    if (forecastLength === 'YTD') {
      return this.params['source'] !== 'IMD_STATION';
    }
    if (forecastLength === 'weekly' || forecastLength === 'monthly' || forecastLength === 'seasonal') {
      return (this.params['view'] || 'Admin') !== 'Basin';
    }
    return true;
  }

  /** Shows/hides the shared google-maps.png marker based on supportsGeoDrilldown() — called
   * whenever this.params changes (time menu, source, view, or drilldown/location). */
  updateGoogleMapsMarkerVisibility() {
    if (!this.map || !this.marker) {
      return;
    }
    const shouldShow = this.supportsGeoDrilldown();
    const isOnMap = this.map.hasLayer(this.marker);
    if (shouldShow && !isOnMap) {
      this.map.addLayer(this.marker);
    } else if (!shouldShow && isOnMap) {
      this.map.removeLayer(this.marker);
    }
  }

  setLocationBasedOnLatLongs(lat: any, lon: any) {
    return this.gisUtils.getFeatureByPoint(lat, lon, 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED').subscribe((geoRes: any) => {
      const feature = geoRes.features[0];
      if (feature) {
        const properties = feature.properties;
        const dist_Name = properties['dist_name'];
        const districtUUID = properties['dist_uuid'];
        const stateName = properties['state_name'].toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
        const stateUUID = properties['state_uuid'];
        let options = { ...this.params };
        options['locName'] = dist_Name;
        options['locType'] = 'DISTRICT';
        options['pUUID'] = districtUUID;
        options['location'] = 'India##00cb31c7-2928-4e6d-adcc-443d478c90d6' + '&' + [stateName, stateUUID].join('##') + '&' + [dist_Name, districtUUID].join('##');
        this.pendingMobileAutoFit = true;
        this.gisUtils.setSelectedParams(options);
        this.gisUtils.getFeatureByUUID(districtUUID, 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED').subscribe(
          (distRes: any) => {
            if (distRes && distRes.features && distRes.features.length > 0) {
              const distLayer = (L as any).geoJSON(distRes);
              const bounds = distLayer.getBounds();
              if (bounds && bounds.isValid() && this.map) {
                this.map.fitBounds(bounds, { padding: [10, 10] });
              }
            }
          },
          (err) => console.error('[enableLocation] getFeatureByUUID error:', err)
        );
      }
    });
  }

  clearMarker() {
    if (this.marker) {
      this.map.removeLayer(this.marker);
      this.marker = null;
    }
  }

  toggleHeatWave() {
    event.stopPropagation(); // 🔥 IMPORTANT
    this.isOpen = !this.isOpen;
  }

  onStationToggle() {
    // Turning STATIONS on is gated behind the app's existing per-module login flow (same
    // pattern as Fog/Lightning: a localStorage flag + the shared UserLoginModule reached via
    // its own route). HeatMap stays on and no station API call happens until login succeeds.
    const needsLogin = this.componentType === 'rainfall-forecast';
    if (needsLogin && !this.isStationActive && localStorage.getItem('isRainfallStationsUserLoggedIn') !== 'true') {
      sessionStorage.setItem('rainfallStationsPendingActivation', 'true');
      // ngOnDestroy() (resetVariablesOnComponentDestroy()) wipes both UtilsService.selectedParams
      // and its sessionStorage('params') mirror as soon as navigating away tears this component
      // down, so the current locType/pUUID/source/component state has to be saved under a
      // dedicated key here to survive the round trip through the login route.
      sessionStorage.setItem('rainfallStationsPendingParams', JSON.stringify(this.params || {}));
      this.router.navigate(['/rainfallstationslogin']);
      return;
    }
    this.isStationActive = !this.isStationActive;
    const svc = this.injectedService;
    if (svc && svc.onStationToggle) {
      svc.onStationToggle(this);
    } else if (svc && svc.onRainfallStationToggle) {
      svc.onRainfallStationToggle(this);
    }
  }

  onAnomalyPercentageToggle() {
    this.isAnomalyPercentageActive = !this.isAnomalyPercentageActive;
    // sourceType ('mean'/'anomaly') is the Ensemble Mean/Ensemble Mean Anomaly selection and
    // must be left untouched here — this toggle only controls the mm vs %age display, which
    // only applies while Ensemble Mean Anomaly is selected.
    let options = { ...this.params };
    // options['sourceType'] = this.isAnomalyPercentageActive ? 'anomaly' : 'mean';
    this.gisUtils.setSelectedParams(options);
  }

  onRadarToggle() {
    this.isRadarToggleActive = !this.isRadarToggleActive;
    this.injectedService.addRadarStationsMarker(this);
  }

  onSourcePillClick(displayLabel: string) {
    const apiValue = this.sourcePillMapping[displayLabel];
    if (!apiValue) return;
    const options = { ...this.params };
    options['source'] = apiValue;
    this.gisUtils.setSelectedParams(options);
  }

  getActivePillLabel(): string {
    if (!this.sourcePillMapping || !this.selectedSource) return '';
    return Object.keys(this.sourcePillMapping).find(k => this.sourcePillMapping[k] === this.selectedSource) || '';
  }

  getHeirarchyData() {
    const heirarchyObj = this.getHeirarchyObj();
    let metaInfo: any = localStorage.getItem('metaInfo');
    let metaInfoJSON = JSON.parse(metaInfo);
    let userlocType: string;
    if (metaInfoJSON && metaInfoJSON.hasOwnProperty('userDetailsJson') && !isNullOrUndefined(metaInfoJSON.userDetailsJson)) {
      userlocType = metaInfoJSON.userDetailsJson.data.locType;
    } else {
      userlocType = 'Country';
    }
    userlocType = userlocType.toUpperCase();
    let userLocHie = LOCATION_HIE;
    let locTypeIndex = userLocHie.indexOf(userlocType);
    const hie = userLocHie.slice(locTypeIndex, 3);
    this.satelliteDataSrv.getHeirarchy(heirarchyObj).subscribe(data => {
      this.inputForBreadcrumb = [];
      if (!isNullOrUndefined(data) && Object.keys(data).length > 0) {
        data.forEach(element => {
          let obj = {
            locType: element['locType'],
            locationID: element['locationID'],
            locationName: element['ln'],
            locationUUID: element['lUUID'],
            clickable: hie.includes(element['locType'])
          };
          this.inputForBreadcrumb.push(obj);
        });
        this.inputForBreadcrumb = this.inputForBreadcrumb.reverse();
      }
    });
  }

  getHeirarchyObj() {
    const heirarchyObj: any = {};
    heirarchyObj['locName'] = this.params['locName'];
    heirarchyObj['locUUID'] = this.params['pUUID'];
    heirarchyObj['locType'] = this.params['locType'];
    heirarchyObj['component'] = 'VL';
    heirarchyObj['view'] = 'ADMIN';
    heirarchyObj['pEUUID'] = 'cc88f822-8474-48d4-8327-4c85444e4a30';
    return heirarchyObj;
  }

  handleEventFromBreadcrumb(data: any) {
    if (this.isSatelliteModule && this.injectedService && this.injectedService.handleEventFromBreadcrumb) {
      this.injectedService.handleEventFromBreadcrumb(data);
      return;
    }
    let currentUrlParams = { ...this.params };
    let locType = data['selectedLocation']['locType'];
    let location = currentUrlParams['location'];
    let options = this.updateBreadCrumbOptions(locType, location, currentUrlParams);
    this.gisUtils.setSelectedParams(options);
  }

  updateBreadCrumbOptions(locType: string, allLocations: string, options: any) {
    let location: string;
    if (locType === 'COUNTRY') {
      location = allLocations.split('&')[0];
      options['locType'] = 'COUNTRY';
      options['locName'] = location.split('##')[0];
      options['location'] = allLocations.split('&')[0];
      options['pUUID'] = location.split('##')[1];
    } else if (locType === 'STATE') {
      location = allLocations.split('&')[1];
      options['locType'] = 'STATE';
      options['locName'] = location.split('##')[0];
      options['location'] = allLocations.split('&')[0] + '&' + allLocations.split('&')[1];
      options['pUUID'] = location.split('##')[1];
    }
    return options;
  }

}
